import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class AdminFrontendUsersNewRoute extends Route {
  // Services
  @service breadcrumb;

  // Hooks
  model() {
    return this.breadcrumb.findRouteModelOrCreateRecord('frontend-user');
  }

  afterModel(model) {
    this.breadcrumb.registerDetailRoute(model);
  }
}
